export enum ScratchRewardType {
  voucher = 'voucher',
  gift = 'gift',
  betterLuckNext = 'betterLuckNextTime',
  freeMovie = 'freeMovie',
  coins = 'coins',
  discountCoupon = 'discountCoupon',
  recharge = 'recharge',
}

export enum CampaignType {
  fixed = 'Fixed',
  random = 'Random',
}

export enum UsageType {
  percentage = 'percentage',
  fixed = 'fixed',
  amount = 'amount',
}

export enum VoucherViewType {
  icon = 'icon',
  small = 'small',
  scratch = 'scratch',
  default = 'default',
  unlucky = 'unlucky',
}

export enum RewardViewType {
  movie = 'movie',
  discount = 'discount',
  voucher = 'voucher',
  coins = 'coins',
  none = 'none',
}

export enum DialogViewType {
  redirect = 'redirect', // for redirect to the movie page
  movieList = 'movieList', // for selection of movie list
  details = 'details', // for voucher details
  scratch = 'scratch', // for scratch card
  unlucky = 'unlucky', // for unlucky
  none = 'none', // for nothing
}

export enum VoucherDetailsType {
  movie = 'movie',
  discount = 'discount',
  voucher = 'voucher',
  none = 'none',
  referral = 'referral',
  film = 'film',
}

export enum VoucherCardType {
  bannerMovie = 'bannerMovie',
  portraitMovie = 'portraitMovie',
  movieSelection = 'movieSelection',
  smallDiscount = 'discount',
  scratchCard = 'scratchCard',
  default = 'default',
  unlucky = 'unlucky',
  coins = 'coins',
  brandVoucher = 'brandVoucher',
}
